import { useTranslation } from 'react-i18next';

const STEPS = [
  { titleKey: 's8.step1', descKey: 's8.step1d' },
  { titleKey: 's8.step2', descKey: 's8.step2d' },
  { titleKey: 's8.step3', descKey: 's8.step3d' },
  { titleKey: 's8.step4', descKey: 's8.step4d' },
  { titleKey: 's8.step5', descKey: 's8.step5d' },
];

export default function ProcessSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-block h-px w-12 bg-primary-500"></span>
          <h2 className="font-heading text-3xl leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
            {t('s8.title')}
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((step, index) => (
            <div
              key={step.titleKey}
              className={`reveal flex flex-col border-t border-foreground-200 pt-6 ${
                index === 1 ? 'reveal-delay-1' : index === 2 ? 'reveal-delay-2' : index === 3 ? 'reveal-delay-3' : index === 4 ? 'reveal-delay-3' : ''
              }`}
            >
              <span className="font-heading text-4xl text-primary-500 md:text-5xl">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 text-lg font-semibold text-foreground-950">
                {t(step.titleKey)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {t(step.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}